import { FCX } from "@datassential/platform-ui-lib";
import './SocialMentions.scss';
import FoodMentionsChart from "@pages/Food/components/SectionSocial/components/MentionsChart/MentionsChart";
import { useMemo } from "react";
import { FoodSocialMetricEnum } from "@pages/Food/components/SectionSocial/SectionSocial";
import { IFoodSocial, ISocialSlice } from "@models/FoodSocial";
import { pctValueSignFormatter } from "@pages/Food/Food.helpers";
import AnimatedNumber from "@pages/Food/components/AnimatedNumber";

const FoodSocialMentions: FCX<{
    selectedMetric: FoodSocialMetricEnum;
    socialData: IFoodSocial['data'];
    selectedMonth: number | null;
    selectedYear: string | null;
    onMentionBarClick: (month: number | null, year: string | null) => void;
}> = ({
    selectedMetric,
    socialData,
    selectedMonth,
    selectedYear,
    onMentionBarClick,
}) => {
    const data = useMemo(
        (): ISocialSlice => {
            if (selectedMetric === FoodSocialMetricEnum.Mentions) {
                return socialData.mentions;
            }

            return socialData.engagement;
        },
        [selectedMetric, socialData],
    );

    return (
        <div className="FoodSocialMentions">
            <div className="FoodSocialMentions__header">
                {selectedMetric === FoodSocialMetricEnum.Mentions ? (
                    <div
                        className="FoodSocialMentions__legend"
                        data-testid="blockFoodSocialMentionsLegend"
                    >
                        {data.sequences.map(({ id, title, color }) => (
                            <div
                                key={id}
                                className="FoodSocialMentions__legend-item"
                            >
                                <div
                                    className="FoodSocialMentions__legend-color"
                                    data-testid="blockFoodSocialMentionsLegendItemColor"
                                    style={{ backgroundColor: color }}
                                />
                                <div
                                    className="FoodSocialMentions__legend-title"
                                    data-testid="textFoodSocialMentionsLegendItemTitle"
                                >
                                    {title}
                                </div>
                            </div>
                        ))}
                    </div>
                ) : <div/>}
                <div className="FoodSocialMentions__header-description">
                    <div>
                        <span data-testid="textFoodSocialMentionsPastTwelveMonthsGrowth">
                            Past 12-Month Growth:&nbsp;
                        </span>
                        <b data-testid="textFoodSocialMentionsPastTwelveMonthsGrowthValue">
                            <AnimatedNumber
                                className="FoodSectionSocial__blur"
                                value={data.yearGrowthPct}
                                valueFormatter={pctValueSignFormatter}
                            />
                        </b>
                    </div>
                    <div>
                        <span data-testid="textFoodSocialMentionsPastOneMonthsGrowth">
                            Past 1-Month Growth:&nbsp;
                        </span>
                        <b data-testid="textFoodSocialMentionsPastOneMonthsGrowthValue">
                            <AnimatedNumber
                                className="FoodSectionSocial__blur"
                                value={data.monthGrowthPct}
                                valueFormatter={pctValueSignFormatter}
                            />
                        </b>
                    </div>
                </div>
            </div>
            <div className="FoodSocialMentions__content">
                <FoodMentionsChart
                    {...data}
                    selectedMonth={selectedMonth}
                    selectedYear={selectedYear}
                    onBarClick={onMentionBarClick}
                />
            </div>
        </div>
    );
};

export default FoodSocialMentions;